import TratamentosConcluidosIcon from '@/components/icons/IndicadoresEsb/Estrategicos/TratamentosConcluidos.vue'

export default {
  value: 'b2',
  label: 'Tratamento concluído',
  iconType: 'component',
  iconComponent: TratamentosConcluidosIcon,
  buscaAtiva: {
    // a: ({ cidadao, formatDate }) =>
    //   `Cidadão ${cidadao?.no_cidadao || '-'} nascido em ${
    //     cidadao?.dt_nascimento ? formatDate(cidadao.dt_nascimento) : '-'
    //   }.`,
    a: 'Pessoa com tratamento odontológico em andamento.',
  },
}
